/**
 * Custom application routes
 *
 * Extends the auto-generated routes with custom routes
 */

import { coreRoutes } from './core.custom';
import { inventoryRoutes } from './inventory.generated';
import { salesRoutes } from './sales.custom';
import { taskmanagementRoutes } from './taskmanagement.custom';
import { workflowRoutes } from './workflow.generated';
import { integrationRoutes } from './integration.generated';
import { procurementRoutes } from './procurement.custom';
import { financeRoutes } from './finance.custom';
import { pricingRoutes } from './pricing.generated';

/**
 * All application routes
 * Combined from all module routes (including custom extensions)
 */
export const appRoutes = [
  ...coreRoutes,
  ...inventoryRoutes,
  ...salesRoutes,
  ...taskmanagementRoutes,
  ...workflowRoutes,
  ...integrationRoutes,
  ...procurementRoutes,
  ...financeRoutes,
  ...pricingRoutes,
];

